import gettext from '@/gettext';
import type { Features } from '@/models';
import DistributionIcon from '/public/icons/distribution.svg';
import GatingIcon from '/public/icons/gating.svg';
import MintIcon from '/public/icons/mint.svg';
import PaidDropIcon from '/public/icons/paid_drop.svg';
import PaymasterIcon from '/public/icons/paymaster.svg';

const { $gettext } = gettext;

export const combinedDropFeatures: Features[] = [
  {
    name: $gettext('Minting on Demand'),
    description: $gettext(
      'Efficient smart contract technology allows for immediate NFT creation when conditions are met, without the need for pre-minted tokens.'
    ),
    isComingSoon: false,
    detailed: true,
    preview: true,
    icon: MintIcon,
  },
  {
    name: $gettext('Drop Any Token'),
    description: $gettext('Distribute tokens seamlessly to your audience.'),
    isComingSoon: false,
    detailed: true,
    preview: true,
    icon: DistributionIcon,
  },
  {
    name: $gettext('Amount Randomizer'),
    description: $gettext('Surprise users with dynamic token distributions.'),
    isComingSoon: false,
    detailed: true,
    preview: true,
    icon: PaidDropIcon,
  },
  {
    name: $gettext('Gating'),
    description: $gettext('Ensure exclusive access with robust gating options.'),
    isComingSoon: false,
    detailed: true,
    preview: true,
    icon: GatingIcon,
  },
  {
    name: $gettext('Paymaster'),
    description: $gettext('Facilitate hassle-free transactions by managing network fees.'),
    isComingSoon: false,
    detailed: true,
    preview: true,
    icon: PaymasterIcon,
  },
  {
    name: $gettext('Paid drop'),
    isComingSoon: true,
    detailed: false,
    preview: true,
  },
];
